<template>
  <b-modal id="domain-setting" size="lg" centered hide-header scrollable no-close-on-backdrop>
    <template #default>
      <!-- カテゴリー編集 -->
      <div id="edit-setting-group" v-if="showEditSetting">
        <b-form-group
          label-size="lg"
          label-class="font-weight-bold"
          id="category-setting-form"
          class="m-0"
        >
          <template #label>
            <div class="d-flex flex-directions-row">
              <div>編集</div>
              <b-badge class="authority-badge admin">管理者以上</b-badge>
            </div>
          </template>
          <b-form-group>
            <b-form-checkbox v-model="allowCatEditExceptGuest"
              >カテゴリー編集をゲスト以外に許可</b-form-checkbox
            >
          </b-form-group>
          <b-form-group class="mb-4">
            <category-edit
              id="category-edit-setting"
              :categories="categories"
              :isMobile="false"
              :domainId="domainId"
              :me="me"
              :attachCategories="[]"
              @onCloseCategoryFilterDialog="() => {}"
            />
            <b-button v-b-modal.category-edit-setting size="sm" variant="info">
              カテゴリー設定を開く
            </b-button>
          </b-form-group>
          <b-form-group
            label="初期値の設定"
            label-class="font-weight-bold"
            id="init-setting"
            class="mb-0"
          >
            <b-form-group label="話題:" class="pl-1">
              <b-form-checkbox v-model="allowTopicWriteOthers"
                >作成者以外の書き込みを許可する</b-form-checkbox
              >
            </b-form-group>
            <b-form-group label="投稿:" class="pl-1">
              <b-form-checkbox id="permit-message-edit" v-model="allowMessageWriteOthers"
                >作成者以外の書き込みを許可する</b-form-checkbox
              >
            </b-form-group>
          </b-form-group>
        </b-form-group>
      </div>

      <!-- ACL設定 -->
      <div id="acl-setting-group" v-if="showAclSetting">
        <b-form-group label-size="lg" label-class="font-weight-bold">
          <template #label>
            <div class="d-flex flex-directions-row">
              <div>組織設定</div>
              <b-badge class="authority-badge admin">管理者以上</b-badge>
            </div>
          </template>
          <b-form-group class="mb-0">
            <!-- ここに権限設定 -->
            <b-button v-b-modal.acl-edit variant="info">権限設定を開く</b-button>
          </b-form-group>
        </b-form-group>
      </div>
      <div id="topic-create-acl-setting-group" v-if="showCreateTopicAclSetting">
        <b-form-group label-size="lg" label-class="font-weight-bold">
          <template #label>
            <div class="d-flex flex-directions-row">
              <div>{{ CREATE_TOPIC_TITLE }}</div>
              <b-badge class="authority-badge owner">所有者のみ</b-badge>
            </div>
          </template>
          <div :class="{ 'setting-description': true, owner: me.isOwnerRole(domainId) }">
            {{ me.isOwnerRole(domainId) ? CREATE_TOPIC_DESC : DEFAULT_DESCRIPTION }}
          </div>
          <b-form-group v-if="me.isOwnerRole(domainId)" class="mb-0">
            <b-form-checkbox v-model="allowCreateTopicByAdmin">{{
              CREATE_TOPIC_ADMIN_LABEL
            }}</b-form-checkbox>
            <b-form-checkbox v-model="allowCreateTopicByUser">{{
              CREATE_TOPIC_USER_LABEL
            }}</b-form-checkbox>
          </b-form-group>
        </b-form-group>
      </div>
      <div id="topic-update-acl-setting-group" v-if="showUpdateTopicAclSetting">
        <b-form-group label-size="lg" label-class="font-weight-bold">
          <template #label>
            <div class="d-flex flex-directions-row">
              <div>{{ UPDATE_TOPIC_TITLE }}</div>
              <b-badge class="authority-badge owner">所有者のみ</b-badge>
            </div>
          </template>
          <div :class="{ 'setting-description': true, owner: me.isOwnerRole(domainId) }">
            {{ me.isOwnerRole(domainId) ? UPDATE_TOPIC_DESC : DEFAULT_DESCRIPTION }}
          </div>
          <b-form-group v-if="me.isOwnerRole(domainId)" class="mb-0">
            <b-form-checkbox v-model="allowUpdateTopicByAdmin">{{
              UPDATE_TOPIC_ADMIN_LABEL
            }}</b-form-checkbox>
          </b-form-group>
        </b-form-group>
      </div>
      <div id="attachment-restriction-group" v-if="showAttachSetting">
        <restrict-type-setting
          form-label-name="添付ファイル"
          :desc="ATTACH_DESC"
          :default-restrict-type="attachRestrictType"
          :default-custom-file-type="attachCustomFileType"
          :isPermitCustom="true"
          :isOwner="me.isOwnerRole(domainId)"
          @change="changeAttchRestrictType"
        ></restrict-type-setting>
      </div>
      <div id="download-group" v-if="showDownloadSetting">
        <restrict-type-setting
          form-label-name="添付ファイルのダウンロード"
          :desc="DOWNLOAD_DESC"
          :default-restrict-type="downloadRestrictType"
          :default-custom-file-type="downloadCustomFileType"
          :isPermitCustom="true"
          :isOwner="me.isOwnerRole(domainId)"
          :filetypes="DONWLOAD_ALLOW_OPTIONS"
          :customOptionAlert="DOWNLOAD_CUSTOM_OPTION_ALERT"
          @change="changeDownloadRestrictType"
        ></restrict-type-setting>
      </div>
      <div id="reaction-group" v-if="showReactionSetting">
        <b-form-group label-size="lg" label-class="font-weight-bold">
          <template #label>
            <div class="d-flex flex-directions-row">
              <div>いいね！の日時表示</div>
              <b-badge class="authority-badge owner">所有者のみ</b-badge>
            </div>
          </template>
          <div :class="{ 'setting-description': true, owner: me.isOwnerRole(domainId) }">
            {{ me.isOwnerRole(domainId) ? REACTION_DESC : DEFAULT_DESCRIPTION }}
          </div>
          <b-form-radio-group
            v-if="me.isOwnerRole(domainId)"
            v-model="showReactionDatePolicy"
            stacked
          >
            <!-- 有効 -->
            <b-form-radio :value="true" @change="changeReactionRadio">有効</b-form-radio>
            <b-form-radio-group
              class="acl-radiobutton"
              v-model="showReactionDateType"
              :options="SHOW_REACTION_DATE_OPTIONS"
              :disabled="!showReactionDatePolicy"
              stacked
            ></b-form-radio-group>
            <!-- 無効 -->
            <b-form-radio :value="false" @change="changeReactionRadio">無効</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </template>
    <template #modal-footer="{ close }">
      <b-row v-if="me.isOwnerRole(domainId)" class="w-100" align-h="around" no-gutters>
        <cancel class="col-5" label="キャンセル" v-on:cancel="close" />
        <confirm
          class="col-5"
          v-on:confirm="showSaveAlert"
          label="保存"
          :disabled="invalidSetting"
        />
      </b-row>
      <b-row v-else class="w-100" align-h="around" no-gutters>
        <cancel class="col-5" label="閉じる" v-on:cancel="close" />
      </b-row>
    </template>
  </b-modal>
</template>

<style lang="scss" scoped>
%grouppBase {
  background-color: whitesmoke;
  padding: 1rem;
}
.authority-badge {
  margin: auto 0 auto auto;
  &.admin {
    background-color: #8ca6b7;
    border-color: #8ca6b7;
  }
  &.owner {
    background-color: #d56c9c;
    border-color: #d56c9c;
  }
}
.setting-description {
  white-space: pre-line;
  &.owner {
    padding: 16px 0;
  }
}

::v-deep #domain-setting {
  #edit-setting-group {
    @extend %grouppBase;
    #init-setting {
      .custom-control {
        padding-left: 2rem;
      }
    }
  }
  #acl-setting-group {
    @extend %grouppBase;
    margin-top: 1rem;
  }
  #topic-create-acl-setting-group {
    @extend %grouppBase;
    margin-top: 1rem;
  }
  #topic-update-acl-setting-group {
    @extend %grouppBase;
    margin-top: 1rem;
  }
  #attachment-restriction-group {
    @extend %grouppBase;
    margin-top: 1rem;
  }
  #download-group {
    @extend %grouppBase;
    margin-top: 1rem;
  }
  #reaction-group {
    @extend %grouppBase;
    margin-top: 1rem;
    .acl-radiobutton {
      padding-left: 1.5em;
    }
  }
}
</style>

<script lang="ts">
import {
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  ref,
  watch,
  type PropType,
} from "vue";
import type Vue from "vue";
import { User, Category } from "../model";
import { useDomainStore } from "@/store";
import CategoryEdit from "@/components/CategoryEdit.vue";
import Cancel from "@/components/button/Cancel.vue";
import Confirm from "@/components/button/Confirm.vue";
import RestrictTypeSetting from "@/components/RestrictTypeSetting.vue";
import { RestrictType, CustomFileType, CustomDeviceType } from "@/domain-setting-types";
import { SetDomainPolicyPayload } from "@/store/domain-store";
import type { AuthorityGroupPolicy, ShowReactionDateType } from "@/support-acl-types";
import {
  CreateTopicAuthorityGroupPolicyDefault,
  ShowReactionDatePolicyDefault,
  ShowReactionDateTypeDefault,
  UpdateTopicAuthorityGroupPolicyDefault,
} from "@/support-acl-types";
import { AttachmentPolicy } from "@/API";
import type { AttachmentFileTypes, DownloadDeviceTypes } from "@/suppport-attachment-types";
import {
  AttachmentFileTypesDefault,
  DownloadDeviceTypesDefault,
  DownloadPolicyDefault,
} from "@/suppport-attachment-types";
import { allowFeature } from "@/direct-app-config";

export default defineComponent({
  name: "domain-setting",
  components: {
    CategoryEdit,
    RestrictTypeSetting,
    Cancel,
    Confirm,
  },
  props: {
    // category-edit
    categories: { type: Array as PropType<Category[]>, default: () => [] },
    domainId: { type: String, default: () => "" },
    me: { type: Object as PropType<User>, default: () => User.createNotFoundUser() },
    // for storybook
    show: { type: Boolean, default: () => false },
    initalCreateTopicAuthorityGroupPolicy: {
      type: Object as PropType<AuthorityGroupPolicy>,
      default: () => CreateTopicAuthorityGroupPolicyDefault,
    },
    initalUpdateTopicAuthorityGroupPolicy: {
      type: Object as PropType<AuthorityGroupPolicy>,
      default: () => UpdateTopicAuthorityGroupPolicyDefault,
    },
    initalAttachRestrictType: {
      type: Number as PropType<RestrictType>,
      default: () => RestrictType.permit,
    },
    initalAttachCustomFileType: {
      type: Array as PropType<CustomFileType[]>,
      default: () => [],
    },
    initalDownloadRestrictType: {
      type: Number as PropType<RestrictType>,
      default: () => RestrictType.omit,
    },
    initalDownloadCustomFileType: {
      type: Array as PropType<CustomDeviceType[]>,
      default: () => [],
    },
    initalShowReactionDatePolicy: {
      type: Boolean,
      default: () => ShowReactionDatePolicyDefault,
    },
    initalShowReactionDateType: {
      type: String as PropType<ShowReactionDateType>,
      default: () => ShowReactionDateTypeDefault,
    },
  },
  setup(props) {
    // $bvModal は BootstrapVue が生やす（Step 3 で composable 化予定）
    const vm = getCurrentInstance()?.proxy as Vue | undefined;

    const DEFAULT_DESCRIPTION = "設定の変更は、所有者へご依頼ください。";
    const ATTACH_DESC =
      "「directの設定に準ずる」を選択している際にdirect側の設定を変更した場合、設定を反映するため掲示板のリロードを実行してください。\nブラウザの場合はブラウザの更新、アプリの場合はトークに一度戻る操作を行ってください。";
    const DOWNLOAD_DESC =
      "「directの設定に準ずる」を選択している際にdirect側の設定を変更した場合、設定を反映するため掲示板のリロードを実行してください。\nブラウザの場合はブラウザの更新、アプリの場合はトークに一度戻る操作を行ってください。\nこちらの設定の「許可」で「iOSアプリ」「Androidアプリ」を選択していても、direct側の設定がダウンロード無効の場合は、iOSアプリ・Androidアプリではダウンロードは行えません。";
    const REACTION_DESC =
      "投稿とコメントへ「いいね！」がされた日時を表示するか設定が行えます。\n日時表示を有効にした場合、所有者は常に閲覧可です。";

    // 話題の作成権限
    const CREATE_TOPIC_TITLE = "話題の作成権限";
    const CREATE_TOPIC_DESC = "所有者は常に作成可、ゲストは常に作成不可です。";
    const CREATE_TOPIC_ADMIN_LABEL = "管理者権限でも作成可とする";
    const allowCreateTopicByAdmin = ref<boolean>(true); // [管理者]話題作成 default: 許可
    const CREATE_TOPIC_USER_LABEL = "ユーザー権限でも作成可とする";
    const allowCreateTopicByUser = ref<boolean>(true); // [ユーザー]話題作成 default: 許可

    // 話題の更新権限
    const UPDATE_TOPIC_TITLE = "話題の編集権限";
    const UPDATE_TOPIC_DESC =
      "所有者は常に編集可、ユーザー・ゲストは常に編集不可です。\n※話題の作成者は、権限に限らず自分が作成した話題は、常に編集可です。\n※編集には削除も含みます。";
    const UPDATE_TOPIC_ADMIN_LABEL = "管理者権限でも編集可とする";
    const allowUpdateTopicByAdmin = ref<boolean>(false); // [管理者]話題更新 default: 禁止

    // 添付ファイルダウンロード設定の許可オプション
    const DONWLOAD_ALLOW_OPTIONS = [
      { text: "Web版", value: "web" },
      { text: "iOSアプリ", value: "ios" },
      { text: "Androidアプリ", value: "android" },
      { text: "デスクトップアプリ", value: "desktop" },
    ];
    const DOWNLOAD_CUSTOM_OPTION_ALERT = "ダウンロードを許可する環境を選択してください";

    // いいね！の時刻表示設定のオプション
    const SHOW_REACTION_DATE_OPTIONS = [
      { text: "所有者のみ閲覧可", value: "owner" },
      { text: "管理者以上が閲覧可", value: "admin" },
      { text: "ユーザー以上が閲覧可", value: "user" },
      { text: "組織内全員が閲覧可", value: "all" },
    ];

    // storeから取得?
    const allowCatEditExceptGuest = ref<boolean>(true);
    const allowTopicWriteOthers = ref<boolean>(true);
    const allowMessageWriteOthers = ref<boolean>(true);

    const attachRestrictType = ref<RestrictType>(RestrictType.permit);
    const attachCustomFileType = ref<CustomFileType[]>([]);
    const downloadRestrictType = ref<RestrictType>(RestrictType.omit);
    const downloadCustomFileType = ref<CustomDeviceType[]>([]);

    const showReactionDatePolicy = ref<boolean>(false);
    const showReactionDateType = ref<ShowReactionDateType>("");

    // 編集権の設定 > 管理者以上
    const showEditSetting = computed((): boolean => {
      return (
        allowFeature("domain-setting-category") &&
        (props.me.isOwnerRole(props.domainId) ||
          props.me.isAdminRole(props.domainId) ||
          props.me.isUserRole(props.domainId))
      );
    });
    // 組織設定 > 管理者以上
    const showAclSetting = computed((): boolean => {
      return (
        allowFeature("domain-settings-acl") &&
        (props.me.isOwnerRole(props.domainId) || props.me.isAdminRole(props.domainId))
      );
    });
    // 話題作成権限設定 > (表示は)管理者以上
    const showCreateTopicAclSetting = computed((): boolean => {
      return props.me.isOwnerRole(props.domainId) || props.me.isAdminRole(props.domainId);
    });
    // 話題更新権限設定 > (表示は)管理者以上
    const showUpdateTopicAclSetting = computed((): boolean => {
      return props.me.isOwnerRole(props.domainId) || props.me.isAdminRole(props.domainId);
    });
    // 添付ファイル設定 > (表示は)管理者以上
    const showAttachSetting = computed((): boolean => {
      return props.me.isOwnerRole(props.domainId) || props.me.isAdminRole(props.domainId);
    });
    // 添付ファイルダウンロード設定 > (表示は)管理者以上
    const showDownloadSetting = computed((): boolean => {
      return props.me.isOwnerRole(props.domainId) || props.me.isAdminRole(props.domainId);
    });
    // いいね！の日時表示設定 > (表示は)管理者以上
    const showReactionSetting = computed((): boolean => {
      return props.me.isOwnerRole(props.domainId) || props.me.isAdminRole(props.domainId);
    });
    // 設定を保存できない(保存ボタンをdisabledにする)条件
    const invalidSetting = computed((): boolean => {
      // 添付の項目で、「許可」かつ「詳細設定のチェックが0」
      // もしくは、保存の項目で「許可」かつ「詳細設定のチェックが0」
      return (
        (attachRestrictType.value === 1 && !attachCustomFileType.value.length) ||
        (downloadRestrictType.value === 1 && !downloadCustomFileType.value.length)
      );
    });

    const changeAttchRestrictType = (prop: {
      restrictType: RestrictType;
      customFileType: CustomFileType[];
    }): void => {
      attachRestrictType.value = prop.restrictType;
      attachCustomFileType.value = prop.customFileType;
    };

    const changeDownloadRestrictType = (prop: {
      restrictType: RestrictType;
      customFileType: CustomDeviceType[];
    }): void => {
      downloadRestrictType.value = prop.restrictType;
      downloadCustomFileType.value = prop.customFileType;
    };

    const changeReactionRadio = (): void => {
      // 「有効」選択時にtypeが未選択なら「所有者のみ閲覧可」を選択
      if (showReactionDatePolicy.value && showReactionDateType.value == "") {
        showReactionDateType.value = "owner";
      }
    };

    const showSaveAlert = async (): Promise<void> => {
      // 添付ファイル、ダウンロード設定
      const policy: SetDomainPolicyPayload = {
        domainId: props.domainId,
        createTopicAuthorityGroupPolicy: CreateTopicAuthorityGroupPolicyDefault,
        updateTopicAuthorityGroupPolicy: UpdateTopicAuthorityGroupPolicyDefault,
        attachmentPolicy: AttachmentPolicy.FOLLOW_DIRECT,
        attachmentFileType: AttachmentFileTypesDefault,
        downloadPolicy: DownloadPolicyDefault,
        downloadDeviceType: DownloadDeviceTypesDefault,
        showReactionDatePolicy: ShowReactionDatePolicyDefault,
        showReactionDateType: ShowReactionDateTypeDefault,
      };

      policy.createTopicAuthorityGroupPolicy = {
        admin: allowCreateTopicByAdmin.value,
        user: allowCreateTopicByUser.value,
      };
      policy.updateTopicAuthorityGroupPolicy = { admin: allowUpdateTopicByAdmin.value };

      // 添付ファイル
      switch (attachRestrictType.value) {
        case RestrictType.omit:
          policy.attachmentPolicy = AttachmentPolicy.DENY;
          break;
        case RestrictType.permit:
          policy.attachmentPolicy = AttachmentPolicy.ALLOW;
          break;
        default:
          policy.attachmentPolicy = AttachmentPolicy.FOLLOW_DIRECT;
          break;
      }
      const attachmentKeys = Object.keys(
        policy.attachmentFileType
      ) as (keyof AttachmentFileTypes)[];
      attachmentKeys.forEach((key) => {
        policy.attachmentFileType[key] =
          attachCustomFileType.value.findIndex((type) => type == key) != -1;
      });

      // ダウンロード
      switch (downloadRestrictType.value) {
        case RestrictType.omit:
          policy.downloadPolicy = AttachmentPolicy.DENY;
          break;
        case RestrictType.permit:
          policy.downloadPolicy = AttachmentPolicy.ALLOW;
          break;
        default:
          policy.downloadPolicy = AttachmentPolicy.FOLLOW_DIRECT;
          break;
      }
      const downloadKeys = Object.keys(policy.downloadDeviceType) as (keyof DownloadDeviceTypes)[];
      downloadKeys.forEach((key) => {
        policy.downloadDeviceType[key] =
          downloadCustomFileType.value.findIndex((type) => type == key) != -1;
      });

      // いいね！の日時表示
      policy.showReactionDatePolicy = showReactionDatePolicy.value;
      if (showReactionDatePolicy.value) {
        policy.showReactionDateType = showReactionDateType.value || "owner";
      }

      await useDomainStore().setDomainPolicy(policy);

      // ダイアログ閉じる
      vm?.$bvModal.hide("domain-setting");
    };

    // Lifecycle
    onMounted(() => {
      // for storybook
      if (props.show) {
        vm?.$bvModal.show("domain-setting");
      }
    });

    // immediate watch 群（全 const / computed / 関数定義後に登録: TDZ 回避）
    watch(
      () => props.initalCreateTopicAuthorityGroupPolicy,
      (): void => {
        if (props.initalCreateTopicAuthorityGroupPolicy.admin !== undefined) {
          allowCreateTopicByAdmin.value = props.initalCreateTopicAuthorityGroupPolicy.admin;
        }
        if (props.initalCreateTopicAuthorityGroupPolicy.user !== undefined) {
          allowCreateTopicByUser.value = props.initalCreateTopicAuthorityGroupPolicy.user;
        }
      },
      { immediate: true }
    );

    watch(
      () => props.initalUpdateTopicAuthorityGroupPolicy,
      (): void => {
        if (props.initalUpdateTopicAuthorityGroupPolicy.admin !== undefined) {
          allowUpdateTopicByAdmin.value = props.initalUpdateTopicAuthorityGroupPolicy.admin;
        }
      },
      { immediate: true }
    );

    watch(
      () => props.initalAttachRestrictType,
      (): void => {
        attachRestrictType.value = props.initalAttachRestrictType;
      },
      { immediate: true }
    );

    watch(
      () => props.initalAttachCustomFileType,
      (): void => {
        attachCustomFileType.value = props.initalAttachCustomFileType;
      },
      { immediate: true }
    );

    watch(
      () => props.initalDownloadRestrictType,
      (): void => {
        downloadRestrictType.value = props.initalDownloadRestrictType;
      },
      { immediate: true }
    );

    watch(
      () => props.initalDownloadCustomFileType,
      (): void => {
        downloadCustomFileType.value = props.initalDownloadCustomFileType;
      },
      { immediate: true }
    );

    watch(
      () => props.initalShowReactionDatePolicy,
      (): void => {
        showReactionDatePolicy.value = props.initalShowReactionDatePolicy;
      },
      { immediate: true }
    );

    watch(
      () => props.initalShowReactionDateType,
      (): void => {
        showReactionDateType.value = props.initalShowReactionDateType;
      },
      { immediate: true }
    );

    return {
      DEFAULT_DESCRIPTION,
      ATTACH_DESC,
      DOWNLOAD_DESC,
      REACTION_DESC,
      CREATE_TOPIC_TITLE,
      CREATE_TOPIC_DESC,
      CREATE_TOPIC_ADMIN_LABEL,
      allowCreateTopicByAdmin,
      CREATE_TOPIC_USER_LABEL,
      allowCreateTopicByUser,
      UPDATE_TOPIC_TITLE,
      UPDATE_TOPIC_DESC,
      UPDATE_TOPIC_ADMIN_LABEL,
      allowUpdateTopicByAdmin,
      DONWLOAD_ALLOW_OPTIONS,
      DOWNLOAD_CUSTOM_OPTION_ALERT,
      SHOW_REACTION_DATE_OPTIONS,
      allowCatEditExceptGuest,
      allowTopicWriteOthers,
      allowMessageWriteOthers,
      attachRestrictType,
      attachCustomFileType,
      downloadRestrictType,
      downloadCustomFileType,
      showReactionDatePolicy,
      showReactionDateType,
      showEditSetting,
      showAclSetting,
      showCreateTopicAclSetting,
      showUpdateTopicAclSetting,
      showAttachSetting,
      showDownloadSetting,
      showReactionSetting,
      invalidSetting,
      changeAttchRestrictType,
      changeDownloadRestrictType,
      changeReactionRadio,
      showSaveAlert,
    };
  },
});
</script>
